import moment from 'moment';

export const momentDateComparator = (date1: string, date2: string): number => {
  const momentDate1 = moment(date1, 'DD/MM/YYYY');
  const momentDate2 = moment(date2, 'DD/MM/YYYY');

  return momentDate1.isBefore(momentDate2) ? -1 : momentDate1.isAfter(momentDate2) ? 1 : 0;
};
